export const invertObj = obj =>
  Object.entries(obj).reduce((acc, entry) => ((acc[entry[1]] = entry[0]), acc), {});
